<template lang="pug">
.slides
  .swiper-container.tutor-slides
    .swiper-wrapper
      .swiper-slide.slide-0
      .swiper-slide.slide-1
      .swiper-slide.slide-2
      .swiper-slide.slide-3
    .swiper-pagination

</template>

<script>
import { Swiper, Pagination, Autoplay } from 'swiper/dist/js/swiper.esm.js'
import { mapState, mapMutations } from 'vuex'
import Raf from 'src/helpers/Raf'

export default {
  name: 'Slides',
  components: {

  },
  data() {
    return {
      swiper: null,
      currIdx: 0,

      _progress: 0,
      _touchX: 0.5,
      _touchY: 1,
      progress: 0,
      touchX: 0.5,
      touchY: 1
    }
  },
  computed: {},
  mounted() {

    this._progress = 0
    this._touchX = 0.5
    this._touchY = 0.5
    Raf.add(this.update)

    Swiper.use([Pagination, Autoplay])
    this.swiper = new Swiper('.tutor-slides', {
      //effect: 'coverflow',
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      //grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: false,

      touchAngle: 90,

      resistance: true,
      resistanceRatio: 0.85,

      on: {
        touchMove: (e) => {
          //console.log(e.touches[0])
          //window.App.setSlideTouch(e.touches[0].pageX, e.touches[0].pageY)
          //window.Slide33.setSlideTouch(e.touches[0].pageX, e.touches[0].pageY)

          this.touchX = e.touches[0].pageX/window.innerWidth
          this.touchY = e.touches[0].pageY/window.innerHeight
        },
        // touchMoveOpposite: (e) => {
        //   //console.log(e.touches[0])
        //   window.App.setSlideTouch(e.touches[0].pageX, e.touches[0].pageY)
        // },
        progress: (p) => {
          //console.log(555, p)
          //window.App.setTutorProgress(p)
          //if (window.Slide33)
            //window.Slide33.setTutorProgress(p)
          this.$emit('progress', p)

          this.progress = p
        },
        touchStart: (e) => {
          if (e.touches)
            if (e.touches[0]){
              //window.App.setSlideOnTouchStart(e.touches[0].pageX, e.touches[0].pageY)
              //if (window.Slide33)
                //window.Slide33.setSlideOnTouchStart(e.touches[0].pageX, e.touches[0].pageY)
              this.touchX = e.touches[0].pageX/window.innerWidth
              this.touchY = e.touches[0].pageY/window.innerHeight
            }
        },
        touchEnd: (e) => {
          //console.log(999999, e)
          //this.$emit('touchend')
          if (e.changedTouches)
            if (e.changedTouches[0]){
              //window.App.setSlideOnTouchEnd(e.changedTouches[0].pageY)
              //if (window.Slide33)
                //window.Slide33.setSlideOnTouchEnd(e.changedTouches[0].pageY)

              this.touchX = 0.5
              this.touchY = e.changedTouches[0].pageY/window.innerHeight

            }
        },
        slideChange: () => {
          //console.log('change', this.swiper.activeIndex)
          //this.currIdx = this.swiper.activeIndex
          //this.$emit('change', this.currIdx)

          //this.currIdx = this.swiper.activeIndex
          //this.$emit('transitionStart', this.currIdx)
        },
        transitionEnd: () => {
          if (this.currIdx === this.swiper.activeIndex) return
          this.currIdx = this.swiper.activeIndex
          this.$emit('transitionStart', this.currIdx)
        },
        transitionStart: () => {
          //this.currIdx = this.swiper.activeIndex
          //this.$emit('transitionStart', this.currIdx)
        }
      }

    })
    //console.log(703, this.swiper)
  },
  beforeDestroy() {
    this.swiper.destroy()
    Raf.remove(this.update)
  },
  methods: {
    ...mapMutations('app', ['setTutorProgress', 'setTutorTouchX', 'setTutorTouchY']),
    update(){
      let dp = this.progress - this._progress
      let dtx = this.touchX - this._touchX
      let dty = this.touchY - this._touchY
      if ((dp*dp + dtx*dtx + dty*dty)<0.0000001) return
      this._progress = this._progress + dp * 0.1
      this._touchX = this._touchX + dtx * 0.2
      this._touchY = this._touchY + dty * 0.2
      this.setTutorProgress(this._progress)
      this.setTutorTouchX(this._touchX)
      this.setTutorTouchY(this._touchY)
      //console.log('easing')
    }


  },
  watch: {},
}
</script>

<style lang="sass">
@import "src/styles/common.sass"
@import "src/styles/helpers/swiper.sass"
.slides
  +full()

.swiper-container
  +full()

.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet
  margin: 0 0.05rem !important

.swiper-pagination-bullet

  use
    &:first-child
      fill: none
    &:last-child
      fill: #ffffff

.swiper-pagination-bullet-active

  use
    &:first-child
      fill: #fff
    &:last-child
      fill: $cl-lightGold

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets
  bottom: $ui-margin
  left: 0
  width: 100%


</style>
